import { normalizePlexCategories } from '../../normalize';
import { GamesStorageType, PlexSetSingleLobbyCategoryArgs } from '../../types';

type PlexSetSingleLobbyCategoryStatePreparator = (
  args: PlexSetSingleLobbyCategoryArgs & { state: GamesStorageType }
) => GamesStorageType;

export const plexSetSingleLobbyCategoryStatePreparator: PlexSetSingleLobbyCategoryStatePreparator =
  ({ state, casinoType, data }) => {
    const normalizedCategories = normalizePlexCategories([data]);
    const [categoryKey, categoryData] = Object.entries(
      normalizedCategories.categories.data
    )[0];
    return {
      ...state,
      lobbies: {
        ...state.lobbies,
        [casinoType]: {
          ...(state.lobbies[casinoType] ?? {}),
          categories: {
            data: {
              ...(state.lobbies[casinoType].categories?.data ?? {}),
              [categoryKey]: {
                ...(state.lobbies[casinoType].categories?.data[categoryKey] ??
                  {}),
                ...categoryData,
                games: [
                  ...new Set([
                    ...(state.lobbies[casinoType].categories?.data[categoryKey]
                      ?.games ?? []),
                    ...(categoryData.games ?? [])
                  ])
                ],
                instantGames: [
                  ...new Set([
                    ...(state.lobbies[casinoType].categories?.data[categoryKey]
                      ?.instantGames ?? []),
                    ...(categoryData.instantGames ?? [])
                  ])
                ]
              }
            },
            ids: [
              ...new Set([
                ...(state.lobbies[casinoType].categories?.ids ?? []),
                ...(normalizedCategories.categories.ids ?? [])
              ])
            ]
          }
        }
      }
    };
  };
